import React from 'react';
import { Grid, Row, Col} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import './Footer.css';

export const Footer = () => (
  <footer>
    <Grid>
      <Row>
        <Col xs={12} md={9}>
          <p>Copyright © 2018 <a href="https://pristine.design">pristine.design</a></p>
        </Col>
        <Col xs={12} md={3}>
          <ul className="list-inline">
            <LinkContainer exact to="/contact">
              <li><a>Contact</a></li>
            </LinkContainer>
            <LinkContainer exact to="/terms">
              <li><a>Terms</a></li>
            </LinkContainer>
          </ul>
        </Col>
      </Row>
    </Grid>
  </footer>
)
            
export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js